export default "__VITE_ASSET__D_lBhAXh__"